export const EVENT_OPEN_MEGA_SHARE_FRIEND_DIALOG = "open-mega-share-friend-dialog";
export const EVENT_CLOSE_MEGA_SHARE_FRIEND_DIALOG = "close-mega-share-friend-dialog";
